import Model from "../../../Model.js";

/**
 * `ReportRow` is the model for a condensed table line.
 *
 * @param {string} spec.name - Name of the line
 * @param {string} spec.id - Unique identifier of the line
 * @param {boolean} spec.isSum - If true, this line represent a sum of its previous lines
 */
export default class ReportRow extends Model {
	constructor(spec) {
		super(spec);
		this._name = spec.name || "";
		this._id = spec.id || this._name;
		this._isSum = spec.isSum;
		this._report = null;
	}

	getName() {
		return this._name;
	}

	getId() {
		return this._id;
	}

	setReport(newReport) {
		this._report = newReport;
	}

	getValue(column) {
		return this._report.getCell({
			column,
			row: this,
		});
	}

	isSum() {
		return this._isSum;
	}

	accept(visitor) {
		return visitor.visitRow(this);
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);

		data.name ||= data.title;
	}
}
